<template>
  <div>
    <div id="print-report">
      <HeaderPrint />

      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <div class="d-flex align-center" style="gap: 16px">
              <div
                class="d-flex align-center"
                style="gap: 16px; flex-wrap: wrap"
              >
                <div>
                  <v-btn
                    small
                    class="white black--text d-print-none"
                    @click="$printReport()"
                  >
                    <v-icon small left>mdi-printer</v-icon>
                    {{ $t("print") }}
                  </v-btn>
                </div>
                <CreateUpdateViewFreespins
                  @fetchFreespins="fetchFreespins"
                  v-if="$permission('117')"
                />
              </div>
              <div
                class="d-md-none d-sm-none d-lg-none d-xl-none align-self-baseline"
              >
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0" ref="desktopBreakpoint">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>

                  <v-btn @click="breakpoint = 'xs'" ref="mobileBreakpoint">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" sm="4">
              <div class="text-right align-end justify-end d-flex">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            :page.sync="page"
            :loading-text="$t('freespins.loading')"
            :mobile-breakpoint="breakpoint"
            :items-per-page="10"
            class="elevation-1"
            :no-data-text="$t('noDataFount')"
            :footer-props="{
              'items-per-page-text': $t('rowsPerPage'),
            }"
          >
            <template v-slot:no-results>
              {{ $t("noDataFount") }}
            </template>

            <template v-slot:header.list_adhesions="{ header }">
              <div class="d-flex align-center">
                <div>
                  <span>
                    {{ header.text }}
                  </span>
                </div>
                <div>
                  <th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="d-print-none"
                        >
                          <v-icon small color="info">
                            mdi-information-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("freespins.claimTooltip") }}</span>
                    </v-tooltip>
                  </th>
                </div>
              </div>
            </template>

            <template v-slot:item.quantity_of_round="{ item }">
              <div class="d-flex align-center">
                {{ item.quantity_of_round }}

                <v-tooltip
                  v-if="item.progressive_spins"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color=""
                      dark
                      v-bind="attrs"
                      v-on="on"
                      right
                    >
                      mdi-chart-timeline-variant-shimmer
                    </v-icon>
                  </template>
                  <span>{{ $t("freespins.progressiveSpins") }}</span>
                </v-tooltip>
              </div>
            </template>

            <template
              v-slot:body="{ items }"
              v-if="items.length > 0 && breakpoint !== 'xs'"
            >
              <tbody name="list" is="transition-group">
                <tr v-for="(item, k) in items" :key="k" class="item-row">
                  <td>
                    <v-btn @click="$copy(item.campaign_id)" x-small>
                      {{ item.campaign_id }}
                    </v-btn>
                  </td>

                  <td>
                    {{ item.title }}
                  </td>

                  <td>
                    <span>
                      {{ item.date_inicial }}
                    </span>
                  </td>

                  <td>
                    <span>
                      {{ item.date_final }}
                    </span>
                  </td>

                  <td>
                    {{ item.quantity_of_round }}
                  </td>

                  <td>
                    <SeeGames :games="item.games" />
                  </td>

                  <td>
                    <v-chip
                      :color="statusUI(item.status)"
                      class="white--text"
                      small
                    >
                      {{ statusValue(item.status) }}
                    </v-chip>
                  </td>

                  <td>
                    {{ item.typeUI }}
                  </td>

                  <td>
                    <div v-if="!item.campaign_code || item.user_selected == 0" class="text-center">
                      ─
                    </div>
                    <v-btn v-else @click="$copy(item.campaign_code)" x-small>
                      {{ item.campaign_code }}
                    </v-btn>
                  </td>

                  <td v-if="$permission('120')">
                    <Adhesions
                      :freespin="item"
                      parent="freespins"
                      :showSeeGames="true"
                    />
                  </td>

                  <td>
                    <span v-if="item.campaign_type == 'personalizado'">
                      ─
                    </span>
                    <span v-else>
                      {{ $t(item.hideUI == 0 ? "displayed" : "hidden") }}
                    </span>
                  </td>

                  <td>
                    <v-btn-toggle>
                      <CreateUpdateViewFreespins
                        :freespin="item"
                        view
                        :fetchedPlayers="fetchedPlayers"
                        @updateFreespinFetchedPlayers="
                          updateFreespinFetchedPlayers
                        "
                      />
                      <CreateUpdateViewFreespins
                        :freespin="item"
                        update
                        @fetchFreespins="fetchFreespins"
                        v-if="$permission('118')"
                        :fetchedPlayers="fetchedPlayers"
                        @updateFreespinFetchedPlayers="
                          updateFreespinFetchedPlayers
                        "
                      />
                      <DeleteFreespins
                        :freespin="item"
                        @removeFreespin="removeFreespin"
                        @fetchFreespins="fetchFreespins"
                        v-if="$permission('121')"
                      />
                    </v-btn-toggle>
                  </td>
                </tr>
              </tbody>
            </template>

            <template v-slot:item.campaign_id="{ item }">
              <v-btn @click="$copy(item.campaign_id)" small>
                {{ item.campaign_id }}
              </v-btn>
            </template>

            <template v-slot:item.title="{ item }">
              {{ item.title }}
            </template>

            <template v-slot:item.list_adhesions="{ item }">
              <Adhesions
                parent="freespins"
                :freespin="item"
                :showSeeGames="true"
              />
            </template>

            <template v-slot:item.games="{ item }">
              <SeeGames :games="item.games" />
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip :color="statusUI(item.status)" class="white--text" small>
                {{ statusValue(item.status) }}
              </v-chip>
            </template>

            <template v-slot:item.campaign_code="{ item }">
              <template>
                <div v-if="!item.campaign_code || item.user_selected == 0" class="text-center">
                  ─
                </div>
                <v-btn v-else @click="$copy(item.campaign_code)" x-small>
                  {{ item.campaign_code }}
                </v-btn>
              </template>
            </template>

            <template v-slot:item.hideUI="{ item }">
              <div
                v-if="item.campaign_type == 'personalizado'"
                class="text-center"
              >
                ─
              </div>
              <span v-else>
                {{ $t(item.hideUI == 0 ? "displayed" : "hidden") }}
              </span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn-toggle>
                <CreateUpdateViewFreespins
                  :freespin="item"
                  view
                  :fetchedPlayers="fetchedPlayers"
                  @updateFreespinFetchedPlayers="updateFreespinFetchedPlayers"
                />
                <CreateUpdateViewFreespins
                  :freespin="item"
                  update
                  :fetchedPlayers="fetchedPlayers"
                  @updateFreespinFetchedPlayers="updateFreespinFetchedPlayers"
                  @fetchFreespins="fetchFreespins"
                  v-if="$permission('118')"
                />
                <DeleteFreespins
                  :freespin="item"
                  @removeFreespin="removeFreespin"
                  @fetchFreespins="fetchFreespins"
                  v-if="$permission('121')"
                />
              </v-btn-toggle>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
import CreateUpdateViewFreespins from "./CreateUpdateViewFreespins";
import DeleteFreespins from "./DeleteFreespins";
import Adhesions from "@/components/common/adhesions";
import SeeGames from "./SeeGames.vue"

export default {
  components: {
    HeaderPrint,
    Adhesions,
    DeleteFreespins,
    CreateUpdateViewFreespins,
    SeeGames
  },

  data: () => ({
    items: [],
    breakpoint: "",
    search: "",
    loading: false,
    page: 1,
    fetchedPlayers: {
      freespinId: [],
    },
  }),

  created() {
    this.$nextTick(() => {
      const ref = this.$vuetify.breakpoint.mobile
        ? "mobileBreakpoint"
        : "desktopBreakpoint";

      this.$refs[ref].$el.click();
    });

    this.fetchFreespins();
  },

  watch: {
    status() {
      this.page = 1;
      this.fetchFreespins();
    },
  },

  computed: {
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    headers() {
      const headers = [
        {
          text: this.$t("freespins.campaignId"),
          value: "campaign_id",
        },
        {
          text: this.$t("freespins.form.campaignTitle"),
          value: "title",
        },
        {
          text: this.$t("dateStart"),
          value: "date_inicial",
        },
        {
          text: this.$t("dateFinal"),
          value: "date_final",
        },
        {
          text: this.$t("freespins.roundsQuantity"),
          value: "quantity_of_round",
          // align: "center"
        },
        // {
        //   text: this.$t("freespins.progressiveSpins"),
        //   value: "progressive_spins",
        // },
        { text: this.$t("games"), value: "games" },
        {
          text: this.$t("status"),
          value: "status",
        },
        {
          text: this.$t("type"),
          value: "typeUI",
        },
        {
          text: this.$t("freespins.form.campaignCode"),
          value: "campaign_code",
        },
      ];

      if (this.$permission("120")) {
        headers.push({
          text: this.$t("claims"),
          value: "list_adhesions",
          sortable: false,
        });
      }

      headers.push(
        {
          text: this.$t("visibility"),
          value: "hideUI",
        },
        {
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
        }
      );

      return headers;
    },
  },

  methods: {
    updateFreespinFetchedPlayers({ campaign_id, players }) {
      this.fetchedPlayers[campaign_id] = players;
    },
    fetchFreespins(changeStatusToActive = false) {
      if (changeStatusToActive) {
        this.$store.commit("setSelectStatus", "1");
      }

      const body = {
        status: changeStatusToActive ? 1 : this.status,
      };

      this.loading = true;
      this.items = [];

      this.$request
        .post(`/${this.$prefix()}/cassino/gamesAgregation/listFreespins`, body)
        .then((response) => {
          if (!response.dados) return;
          this.items = response.dados.map((item) => {
            return {
              ...item,
              originalInitialDate: item.start_date,
              originalFinalDate: item.final_date,
              date_inicial: item.start_date
                ? new Date(
                    item.start_date.replace(" ", "T")
                  ).toLocaleTimeString([], {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "",
              date_final: item.final_date
                ? new Date(
                    item.final_date.replace(" ", "T")
                  ).toLocaleTimeString([], {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "",
              typeUI: this.typeUI(item.campaign_type ? item.campaign_type : "personalizado"),
              hideUI:
                item.campaign_hide && item.campaign_type != 0
                  ? item.campaign_hide
                  : -1,
            };
          });

          function compare(a, b) {
            if (a.campaign_id < b.campaign_id) {
              return 1;
            }
            if (a.campaign_id > b.campaign_id) {
              return -1;
            }
            return 0;
          }

          this.items.sort(compare);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    statusUI(value) {
      if (value == 0) return "purple darken-2"; // Expirada
      if (value == 1) return "green"; // Ativa
      if (value == 2) return "grey darken-4"; // Suspensa
      if (value == 3) return "red lighten-1"; // Cancelada
      if (value == 4) return "red lighten-1"; // Parcialmente Cancelada
    },
    statusValue(value) {
      const obj = {
        0: this.$t("expiredPromo"),
        1: this.$t("activePromo"),
        2: this.$t("suspensa"),
        3: this.$t("cancelledPromo"),
        4: this.$t("cancelledPromo"),
      };
      return obj[value];
    },
    removeFreespin(id) {
      this.items = this.items.filter((freespin) => freespin.campaign_id !== id);
    },
    typeUI(value) {
      const obj = {
        personalizado: this.$t("freespins.campaignTypeOptions.custom"),
        deposito: this.$t("freespins.campaignTypeOptions.deposit"),
        "1ºdeposito": this.$t("freespins.campaignTypeOptions.firstDeposit"),
      };
      return obj[value];
    },
  },
};
</script>

<style>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.5s;
}
</style>
